// Server Component (App Router)

import GeneralContact from "./GeneralContact";

interface ContactUSProps {
  variant?: "default" | "alt";
  formType?: "contact" | "career",

}

export default function ContactUS({ variant = "default", formType = "contact" }: ContactUSProps) {
  return <GeneralContact variant={variant} formType={formType} />;
}
